import { Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { NavigationService } from '../../../app/services/navigation.service';

export enum LeaveVenue {
	NAVIGATE_BACK = 'back',
	STAY = 'stay',
}
@Component({
	selector: 'app-change-venue-popover',
	templateUrl: './change-venue-popover.component.html',
	styleUrls: ['./change-venue-popover.component.scss'],
})
export class ChangeVenuePopoverComponent implements OnInit {
	leaveEnum = LeaveVenue;
	constructor(private popoverCtr: PopoverController, private navigationService: NavigationService) {}

	ngOnInit() {}
	dismiss(value: LeaveVenue) {
		this.popoverCtr.dismiss(value);
	}
	async change() {
		await this.popoverCtr.dismiss();
		await this.navigationService.home();
	}
}
